module.exports = __webpack_public_path__ + "img/video2-placeholder.e491c1a0.png";